<script>
export default {
  name: 'NonDynamicTransportItineraries',
  props: {
    itineraryIds: {
      type: Array,
      default: () => [],
    },
    transportId: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTransportItinerariesModal: false,
    };
  },
  methods: {
    openItinerary(itinerary) {
      location.href = `/itinerary/edit/${itinerary.id}/general`;
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="showTransportItinerariesModal"
    width="700"
  >
    <v-card>
      <v-list lines="two">
        <template v-for="(itinerary, index) in itineraryIds">
          <v-divider v-if="index" :key="itinerary.id"></v-divider>
          <v-list-tile @click="openItinerary(itinerary)" :key="itinerary.id">
            <v-list-tile-content>
              <v-list-tile-title>{{ itinerary.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-card>

    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="!transportId || itineraryIds.length == 0"
        color="primary lighten-2"
        v-on="on"
      >
        <v-icon dark left>backup</v-icon>Show Itineraries
      </v-btn>
    </template>

  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportItineraries.vue